import React, { Component } from 'react';
import {Head, Link, withRouteData} from 'react-static';
import styled from "styled-components";

import Header from '../components/Header';
import Footer from '../components/Footer';
import SocialLinks from "../components/SocialLinks";

const TermsStyle = styled.div`
	h4 {
		margin-top: 1.5rem;
	}
	
	p > p {
		margin-bottom: 0;
	}
	
	.container {
		margin-bottom: 2rem;
	}
`;

class Terms extends Component {
	render() {
		return (
			<TermsStyle>
				<Head>
					<title>Refund Policy | CTR Group</title>
					<meta name="description" content="Please follow the link to read our Refund Policy. If you have any questions, please contact our support team." />
				</Head>
				<Header />
				<div>
					<div className="container">
						<div className="row">
							<div className="columns medium-12">
								<h1 className="green text-center small-centered">Refund Policy</h1>
								<p className="caption">
									This Refund Policy is an integral part of the <Link to={`${this.props.language === "" ? "" : "/"}${this.props.language}/terms-of-service`}>Terms of Service</Link> of the site
									https://ctr.group. Accepting the terms and
									conditions set forth in the User Agreement, you hereby accept this Refund Policy.
									<br/>After you register on the website of Sonera Corporative Ltd., hereinafter referred to as the "Service
									Provider", it will receive certain information about you and provide you with services related to the
									use of the personal cabinet, which will be the fulfillment of the obligations provided for in this User
									Agreement.
								</p>

								<h4 className="green">REFUND AFTER TOPPING UP YOUR BALANCE</h4>
								<p className="caption">
									After replenishing the balance in any way presented in the personal account, you can return the
									deposit within 48 hours by contacting the Service Provider's support service by sending a message
									to refund@ctr.group. In some cases, you will need to provide the Service Provider with additional
									data to effect a refund. At the same time, you agree that the amount of the refund will be less than
									the amount of the deposit for the amount necessary to process the payment. More detailed
									information about the commission can be obtained on an individual written request. The deposit is
									refunded within 5 (five) business days.
								</p>

								<h4 className="green">REFUND UPON ORDER CANCELLATION</h4>
								<p className="caption">
									You have the right to cancel the purchase after replenishing your account within 48 hours.
									<br/>To cancel an order, you need to enter your personal account, copy the order information that you
									wish to cancel, and insert this information into the body of the letter requesting a refund. In some
									cases, you will need to provide the Service Provider with additional data to effect a refund. At the
									same time, you agree that the amount of the refund will be less than the amount of the deposit for
									the amount necessary to process the payment. More detailed information about the commission can
									be obtained on an individual written request. The deposit is refunded within 5 (five) business days.
									The status of the canceled transaction will be changed within 48 hours.
									<br/>Please note that your transaction will not be canceled and you will not be eligible for a refund if you
									send a cancellation request after the cancellation period has expired.
								</p>

								<h4 className="green">REFUND UPON TERMINATION OF USE</h4>
								<p className="caption">
									Regardless of the reasons for the termination of the use of the Website, cash on the balance of your
									account that has not been withdrawn will be returned only after you have contacted the Service
									Provider in writing, confirm your identity, the right to use the account and funds on the account. From
									the positive balance on your account, the amount necessary to process the transaction will be
									deducted, as well as the amount of your possible debt to the Service Provider. The terms of the
									refund and the amount of deduction are discussed individually in each specific case and depend on
									the situation.
								</p>

								<h4 className="green">REFUND UPON INACTIVITY OF THE ACCOUNT</h4>
								<p className="caption">
									If you do not use your account for more than 12 months, it will be deactivated, and funds from your
									account will be returned in accordance with the return rules provided for cases of termination of use
									of the website.
								</p>

								<h4 className="green">OTHER REFERENCES</h4>
								<p className="caption">Also see our <Link to={`${this.props.language === "" ? "" : "/"}${this.props.language}/terms-of-service`}>Terms of Service</Link> and our <Link to={`${this.props.language === "" ? "" : "/"}${this.props.language}/payment-policy`}>Payment Policy</Link>.</p>


								<h4 className="green">CONTACT</h4>
								<p className="caption">For general inquiries, you can contact us by E-Mail at <a href="mailto:info@ctr.group">info@ctr.group</a></p>
								<p className="caption">If you have a technical or site related issue, contact us at <a href="mailto:support@ctr.group">support@ctr.group</a></p>
								<p className="caption">You can also join our <a href="https://t.me/ctrgroupico" target="_blank" rel="noopener noreferrer">Telegram Channel</a></p>
							</div>
						</div>
					</div>
				</div>
				<SocialLinks />
				<Footer />
			</TermsStyle>
		)
	}
}

export default withRouteData(Terms)


// WEBPACK FOOTER //
// /opt/build/repo/src/containers/ReturnPolicy.js